import { createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import { firestore } from "../Firebase/config";
import {
  getDocs,
  updateDoc,
  doc,
  collection,
  query,
  where,
} from "firebase/firestore";

const initialState = {
  workoutPlane: {},
  workoutId: "",
};

// export const setWorkoutData = createAsyncThunk(
//   "setWorkoutData",
//   async () => {
    
//     try {
//       const docRef = await addDoc(collection(firestore, "workout"), {
//         userId: ,
//         workoutPlane: {},
//       });
//       return docRef.id;
//     } catch (error) {
//       console.log(error);
//     }
//   }
// );

export const updateWorkoutData = createAsyncThunk(
  "updateWorkout",
  async (payload) => {
    // console.log(payload.workout);
    try {
      const docRef = await doc(firestore, "workout", payload.workoutId);

      await updateDoc(docRef, {
        workoutPlane: payload.workout,
      });
    } catch (error) {
      // console.log(error);
    }

    return payload.workout;
  }
);

export const getWorkoutData = createAsyncThunk(
  "getWorkoutData",
  async (userId) => {
    const getQuery = query(
      collection(firestore, "workout"),
      where("userId", "==", userId)
    );

    const res = await getDocs(getQuery);

    const workout = res.docs.map((doc) => doc);

    return { workoutId: workout[0].id, workoutPlane: workout[0].data() };
  }
);

// const getWorkoutData = createAsyncThunk("getWorkoutData", async (userId) => {

// })

const workoutSlice = createSlice({
  name: "workout",
  initialState,
  reducers : {
        defaultData : (state, action) => {
          state.workoutId = action.payload

        }},
  extraReducers: (builder) => {
    // builder.addCase(setWorkoutData.fulfilled, (state, action) => {
    //   state.workoutId = action.payload;
    // });

    // builder.addCase(setWorkoutData.rejected, (state, action) => {
    //   console.log(action.error);
    // });
    builder.addCase(updateWorkoutData.fulfilled, (state, action) => {
      state.workoutPlane = action.payload;
    });

    builder.addCase(updateWorkoutData.rejected, (action) => {
      // console.log(action);
    });

    builder.addCase(getWorkoutData.fulfilled, (state, action) => {
      state.workoutPlane = action.payload.workoutPlane.workoutPlane;
      state.workoutId = action.payload.workoutId;
    });
  },
});

export default workoutSlice.reducer;

export const { defaultData } = workoutSlice.actions;
